<template>
<div>
    <message-card class="mb-3" state="bad" :message="error_message"></message-card>

    <card v-if="facility && !facility.user.has_changed_password" size="small" :no-footer="true" class="mb-3">
        <template slot="body">
            <div class="flex ai-c jc-sb">
                <span class="danger-text">To improve security, please consider changing the password that was generated for your account.</span>

                <button class="danger small" :disabled="is_loading_user" type="button" @click="change_password_modal_open = true">Change Password</button>
            </div>
        </template>
    </card>

    <card>
        <template slot="header">
            <i class="material-icons">contact_mail</i>
            <strong class="ml-2">Your Profile</strong>
        </template>

        <template slot="body">
            <form :disabled="is_loading_user || is_saving_user" @submit.prevent="saveUser">
                <div class="flex">
                    <div class="flex-50 mr-3">
                        <label for="username">Username</label>
                        <input disabled id="username" type="text" v-model="user.username" />
                    </div>

                    <div class="flex-50 ml-3">
                        <label for="email">Email</label>
                        <input
                            disabled
                            id="email"
                            type="email"
                            :value="changes.email || user.email"
                            @input="(ev) => changes.email = ev.currentTarget.value.trim()" />
                    </div>
                </div>

                <div class="flex mt-3">
                    <div class="flex-50 mr-3">
                        <label for="real-name">Manager Name</label>
                        <input
                            :disabled="is_loading_user || is_saving_user"
                            id="real-name"
                            type="text"
                            :value="changes.real_name || user.real_name"
                            @input="(ev) => changes.real_name = ev.currentTarget.value.trim()" />
                    </div>

                    <div class="flex-50 ml-3">
                        <!-- Not visible! -->
                        <button type="submit" style="display: none;">Submit</button>
                    </div>
                </div>
            </form>

            <div class="flex ai-c jc-fe mt-6">
                <button :disabled="is_loading_user" class="tertiary mr-3" type="button" @click="change_password_modal_open = true">Change Password</button>

                <button :disabled="is_loading_user || is_saving_user" type="submit" @click="saveUser">Update</button>
            </div>
        </template>
    </card>

    <modal v-show="change_password_modal_open" @close="change_password_modal_open = false">
        <template slot="header">
            Change Password
        </template>

        <template slot="content">
            <div class="hint">Password must be at least 6 characters long.</div>
            <div class="hint mt-1">Spaces at the beginning and end will be removed.</div>

            <form :disabled="is_changing_password" class="mt-4" @submit.prevent="changePassword">
                <div class="flex">
                    <div class="flex-50 mr-3">
                        <label for="password-change">Password</label>
                        <password-input
                            id="password-change"
                            @change="(p) => change_password.password = p"
                            :input-value="change_password.password"
                            label="password-change"></password-input>
                    </div>

                    <div class="flex-50 ml-3">
                        <label for="password-change-confirm">Confirm Password</label>
                        <password-input
                            id="password-change-confirm"
                            @change="(p) => change_password.confirm = p"
                            :input-value="change_password.confirm"
                            label="password-change-confirm"></password-input>
                    </div>

                    <!-- Not visible! -->
                    <button type="submit" style="display: none;">Save</button>
                </div>
            </form>
        </template>

        <template slot="footer">
            <div class="flex ai-c jc-sb">
                <div>
                    <span v-show="password_validation_error.length">{{ password_validation_error }}</span>
                </div>

                <div class="flex">
                    <div v-show="is_changing_password" class="flex ai-c mr-2">
                        <img src="../assets/img/loading-black-32.gif" alt="loading" />
                    </div>

                    <button :disabled="is_changing_password" type="button" @click="changePassword">Update</button>
                </div>
            </div>
        </template>
    </modal>
</div>
</template>

<script>
import store from "@/store"

export default {
    name: "profile-page",

    data () {
        return {
            change_password: {
                confirm: "",
                password: ""
            },
            change_password_modal_open: false,
            changes: {},
            clean: true,
            error_message: "",
            is_changing_password: false,
            is_loading_user: false,
            is_saving_user: false,
            password_validation_error: "",
            permissions: []
        }
    },

    computed: {
        facility () {
            return store.state.userFacility.facility
        },

        user () {
            return store.state.user
        }
    },

    methods: {
        async changePassword () {
            const newPassword = this.change_password.password.trim()
            const confirmPassword = this.change_password.confirm.trim()

            if (newPassword.length < 6) {
                this.password_validation_error = "Password must be at least 6 characters."
            } else if (newPassword !== confirmPassword) {
                this.password_validation_error = "Password fields do not match."
            } else {
                this.password_validation_error = ""
                this.is_changing_password = true

                try {
                    await store.dispatch("changePassword", newPassword)
                    store.dispatch("userFacility/loadFacility")

                    this.$eventManager.emit("add-toast", { message: "Password has been updated!" })
                    this.is_changing_password = false
                    this.change_password_modal_open = false
                } catch (ex) {
                    // TODO handle error
                }
            }
        },

        async saveUser () {
            this.error_message = ""
            this.is_saving_user = true

            try {
                await store.dispatch("updateProfile", this.changes)

                this.$eventManager.emit("add-toast", { message: "Profile has been updated!" })
                this.changes = {}
            } catch (ex) {
                this.error_message = ex
            } finally {
                this.is_saving_user = false
            }
        }
    }
}
</script>

<style>
.profile-table {
    border-collapse: collapse;
    table-layout: fixed;
}

.profile-table td:first-child {
    text-align: right;
}

.profile-table td:last-child {
    padding-left: 10px;
}

.password-warning {
    color: #ff6050;
    margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProfilePage.vue